export default "__VITE_ASSET__CdPuF22l__"